import { Injectable } from '@angular/core';
import { APP_REGEX } from '../contants/APP_REGEX';

@Injectable()
export class CommonService {

	constructor() { }


	//this function expects upto 2 layers of object only, 1st layer is the passed object
	objectToQueryParam(object: any): string {
		let param = '';
		for (var prop in object) {
			let item =  object[prop];
			if (typeof item == 'object') {
				for (var propB in item) {
					if(item[propB] !== null && item[propB] !== undefined)
						param += `${prop}.${propB}=${item[propB]}&`;
				}
			} else if(item !== null && item !== undefined){				
				param += `${prop}=${item}&`;
			}
		}

		return `?${param}`;
	}

	isCurrency(value: string): boolean {
		return APP_REGEX.currency.test(value);
	}

	insertAt(destination: any[], index: number, newValues: any[]){
		index = index < 0 ? 0 : index;

		newValues.forEach(x => {
			destination[index] = x;
			index++;
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/services/common.service.ts